export const MAX_FOLDERS = 15
export const MOVE_TO_FOLDER_LOCATION = {
  MULTI_SELECT: 'multiSelect',
  ASSESSMENT_CARD: 'assessmentCard'
} as const
export const TOAST_MESSAGES = {
  FOLDER_MOVED_TO_FOLDER: 'Assessment(s) moved to',
  FOLDER_ARCHIVED: 'Assessment(s) moved to Archive'
} as const
